import { Record } from "appworks/model/gameplay/records/record";
import { Result } from "appworks/model/gameplay/records/results/result";
import { ResultBuilder } from "appworks/server/builders/result-builder";
import { Point } from "appworks/utils/geom/point";
import { SpinRecord } from "slotworks/model/gameplay/records/spin-record";

export class ThemeHarpoonResult extends Result {
    public resultType: string = "ThemeHarpoonResult";
    public position: Point;
    public trailLevel: number;
}

export class ThemeHarpoonResultBuilder implements ResultBuilder {
    public filter(data: any, record: Record): boolean {
        return data.coLocations !== undefined;
    }

    public build(record: SpinRecord, data: any, additionalData?: any): Result[] {
        // server locations don't take reel padding into account so we need to do that here,
        // because this also happens before the pad-grid-supplement
        const offsets: number[] = record.grid.map((reel) => {
            return 7 - reel.length;
        });

        const results: ThemeHarpoonResult[] = data.coLocations.map((loc: number[]) => {
            const result = new ThemeHarpoonResult();
            result.position = new Point(loc[0], loc[1] + offsets[loc[0]]);
            result.trailLevel = data.numberOfCO;
            return result;
        });

        results.forEach((result, index, array) => {
            result.trailLevel += index - (array.length - 1);
        });

        return results;
    }

}
